import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import axios from 'axios';

import '../../styles/inventario.css';
import './HardwaresPorUsuario.css';
import ListaHardwares from '../../components/ListaHardware/ListaHardware';

import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../../../config/backend';

function HardwaresUsuario(props) {

    const history = useHistory();

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware/porUsuario", {
                headers: { Authorization: `${token}` },
                params: { codUsu: props.match.params.id }
            });
            const raw = Array.isArray(response.data) ? response.data : [];
            const listaHardware = raw.map((r) => ({
                codhar: r.codhar ?? r.CODHAR,
                codeqp: r.codeqp ?? r.CODEQP,
                sereqp: (r.sereqp ?? r.SEREQP ?? '').toString(),
                pateqp: (r.pateqp ?? r.PATEQP ?? '').toString(),
                deseqp: (r.deseqp ?? r.DESEQP ?? '').toString(),
                siteqp: (r.siteqp ?? r.SITEQP ?? '').toString()
            }));
            setData(listaHardware);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            setData([]);
        }
    };

    useEffect(() => {
        verificar();    
        fetchData();

        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, []);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <form>
                <div className="">
                    <p></p>
                    <div className="container-fluid titulo inventario-page">

                        <h1>Hardwares por Usuário</h1>
                        <div className="col-8 mt-4">
                            
                        </div>
                        <ListaHardwares arraysHardware={data} />
                    </div>

                </div>

            </form>
            <div className='container-fluid d-flex ml-5'>
                <Link to="/home" className="btn btn-secondary ms-auto mb-4 mt-3" type="button" >Voltar</Link>
            </div>
            </main>
        </div>
    );
}

export default HardwaresUsuario;
